import { NavLink } from 'react-router-dom'

import { useT } from '@/i18n'
import type { MessageKey } from '@/i18n'
import { cn } from '@/lib/cn'

// 密钥放第一个：三种协议都要用它认身份，是所有接入方式的第零步。
const tabs: { to: string; label: MessageKey }[] = [
  { to: '/settings/keys', label: 'access.tabKeys' },
  { to: '/settings/amcp', label: 'access.tabAmcp' },
  { to: '/settings/mcp', label: 'access.tabMcp' },
  { to: '/settings/api', label: 'access.tabApi' },
]

/** 接入方式之间切换。它们面向的是同一套能力，只是协议不同。 */
export function AccessTabs() {
  const t = useT()
  return (
    <nav className="flex border-b border-line" aria-label={t('access.tabsLabel')}>
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            cn(
              'flex-1 py-3 text-center text-[15px] transition-colors hover:bg-surface-hover',
              isActive ? 'font-bold' : 'text-ink-muted',
            )
          }
        >
          {({ isActive }) => (
            <span className={cn('inline-block pb-2', isActive && 'border-b-4 border-brand-ink')}>
              {t(tab.label)}
            </span>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
